// extracted by mini-css-extract-plugin
module.exports = {"root":"HealthCreateEdit_root__29Z7t"};